import { IconCallAlt, IconEmail } from '../../icon';
import Link from '../../link';
import { cn } from '@fshr/shared-react';
import { translate } from '@micro-apps/env';
import classNames from 'classnames';
import BevSafeText from '../../bev-safe-text';

type Props = {
	title?: string;
	explanation?: string;
	phone?: string;
	email?: string;
	buttonText?: string;
	buttonLink?: string;
	isMobile?: boolean;
	isHeroVariant?: boolean;
};

const Offline = ({
	title,
	explanation,
	phone,
	email,
	buttonText,
	buttonLink,
	isMobile = false,
	isHeroVariant = false,
}: Props) => {
	return (
		<div
			className={classNames('Overlay_caw flex', {
				'spacing-card-padding-s bg-surface-raised-subtle border-border-subtle rounded-[1px] w-full':
					isHeroVariant && !isMobile,
			})}
		>
			<div className="w-full">
				<div
					className={classNames('Overlay_caw_wrap flex flex-col header:flex-row', {
						'justify-start gap-y-[25px] spacing-inline-l': !isHeroVariant,
						'w-full gap-[40px] items-center justify-between': isHeroVariant && !isMobile,
					})}
				>
					<div
						className={classNames(' Overlay_caw_contents max-w-full flex flex-col', {
							'gap-[6px]': isHeroVariant && !isMobile,
							'spacing-stack-s': !isHeroVariant,
						})}
					>
						<div className="flex flex-row gap-100 justify-start items-center">
							{title && (
								<p className="Overlay_caw_title m-0 text-subtitle2">
									<BevSafeText>{title}</BevSafeText>
								</p>
							)}
						</div>
						{explanation && (
							<span className="Overlay_caw_body text-body2 pb-[5px] header:text-[16px] header:pb-0">
								{explanation}
							</span>
						)}
						{(phone || email) && (
							<div
								className={cn(
									'Overlay_caw_body Overlay_caw_offline_contactLinks flex flex-col items-start flex-row',
									{
										'gap-300': isMobile,
										'spacing-inline-l': !isMobile,
									}
								)}
							>
								{phone && (
									<div className="Overlay_caw_offline_phone">
										<Link
											intent="text"
											icon={<IconCallAlt width={20} height={20} />}
											iconPosition="start"
											href={`tel:${phone.replace(/\D+/g, '')}`}
											className="Overlay_caw_offline_phoneLink flex flex-row gap-100 [&_svg]:min-w-[20px]"
										>
											<span
												className={cn('border-b pb-[3px]', {
													'text-caption3': isMobile,
													'text-button1': !isMobile,
												})}
											>
												{phone}
											</span>
										</Link>
									</div>
								)}
								{email && (
									<div className="Overlay_caw_offline_email">
										<Link
											intent="text"
											icon={<IconEmail width={20} height={20} />}
											iconPosition="start"
											href={`mailto:${email}`}
											className="Overlay_caw_offline_emailLink flex flex-row gap-100 [&_svg]:min-w-[20px]"
										>
											<span
												className={cn('border-b pb-[3px]', {
													'text-caption3': isMobile,
													'text-button1': !isMobile,
												})}
											>
												{translate('Email Us')}
											</span>
										</Link>
									</div>
								)}
							</div>
						)}
					</div>
					{buttonLink && buttonText && (
						<div className="w-auto flex items-center">
							<Link
								intent="outline"
								className="Overlay_caw_button bg-button-primary rounded-[5px] text-button-primary-inverse hover:bg-button-primary-hover hover:text-button-primary-inverse active:bg-button-primary-hover active:border-button-primary-hover active:text-button-primary-inverse focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-button-primary focus-visible:ring-offset-2"
								href={buttonLink}
							>
								<span className="text-button2">{buttonText}</span>
							</Link>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Offline;
